import { usePricing } from '@forwardflow/modules/onboarding/hooks'
import { User01Icon } from '@forwardflow/icons'
import { Stack, Group } from '@forwardflow/ui-v2'

export const PricingSummary = () => {
   const { seatsCount, newLeadCount, reactivateLeadCount, totalCost } =
      usePricing()

   return (
      <Group
         justify="space-between"
         align="center"
         className="rounded-[16px] p-4 border border-[#B17AFF]/[0.5] bg-[linear-gradient(111deg,rgba(159,123,255,0.10)_1.32%,rgba(235,105,194,0.10)_96.08%)]"
      >
         <Group>
            <Group
               justify="center"
               align="center"
               className="w-12 h-12 rounded-lg border border-[#8E51FF] bg-gradient-to-br from-[#4F39F6]/30 to-[#7F22FE]/30"
            >
               <User01Icon color="#A684FF" className="w-6" />
            </Group>
            <Stack gap={2}>
               <p className="text-white font-medium text-base">
                  Your Monthly Subscription Price
               </p>
               <p className="text-white/70 text-sm">
                  {seatsCount > 10 ? 'Unlimited' : seatsCount} users /{' '}
                  {newLeadCount} new leads / {reactivateLeadCount} revive leads
               </p>
            </Stack>
         </Group>
         <p className="text-white font-medium text-base pr-8">
            <span className="text-white font-semibold text-2xl">
               ${totalCost}
            </span>
            <span className="text-white font-medium">/Month</span>
         </p>
      </Group>
   )
}
